import { DataPackSyncControl } from 'app/models/dataPackSyncControl.model';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { BlockGroupService } from '../../../../../app/services/block.group.service';
import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';
import { BindComponentService } from '../../../../utils/bind.component.service';
import { VivoSyncService } from 'app/services/vivo.sync.service';
import { DataPackSyncQueue } from 'app/models/dataPackSyncQueue.model';
/**
 * @version $Id$
 */
@Component({
  selector: 'configureSyncModal',
  templateUrl: './content.template.html'
})
export class ConfigureSyncModalComponent implements OnInit {

  private static readonly ACTION_ACTIVATE = 'activateLines';
  private static readonly ACTION_DEACTIVATE = 'deactivateLines';

  @Input() group: DataPackGroup = new DataPackGroup();
  @Input() lineAcountList: any[];
  @Input() dataPackLine: DataPackLine = new DataPackLine();
  @Input() isGroup: boolean;
  @Input() isShowLineErrors: boolean = false;
  @Input() queueList: Array<DataPackSyncQueue> = new  Array<DataPackSyncQueue>();
  private action= '';
  private saving: boolean;

  constructor(private bindComponent: BindComponentService, private activeModal: NgbActiveModal,
    private vivoSyncService: VivoSyncService, private alertService: AlertService) {
  }

  ngOnInit() {
  }

  private close() {
    this.activeModal.dismiss();
  }

  private apply() {
    this.saving = true;
    const payload = {
      action: this.action,
      isGroup: this.isGroup,
      sourceGroup: {
        id: this.group.id
      },
      lines: []
    };

    this.lineAcountList.forEach((packLine: DataPackLine) => {
      payload.lines.push({
        lineNumber: packLine.lineNumber,
        syncAllowed: packLine.syncAllowed
      });
    });
    const promise = this.action === ConfigureSyncModalComponent.ACTION_ACTIVATE ?
     this.vivoSyncService.activateLines(payload) : this.vivoSyncService.deactivateLines(payload);
    promise.subscribe(
      data => {
        this.activateSuccess(data);
      },
      err => {
        this.activateError(err);
      }
    );
  }

  public activateSuccess(data: any){
    this.alertService.success(data.result);
    this.saving = false;
    this.activeModal.close(this.action);
    this.bindComponent.set(BindComponentService.LOAD_VIEW_VIVO_SYNC, true);
  }
  public activateError(err: any){
    this.saving = false;
    this.alertService.error(err.result, err);
    this.activeModal.dismiss();
    this.bindComponent.set(BindComponentService.LOAD_VIEW_VIVO_SYNC, true);
  }

}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/vivosync/configure/content.component.ts